import React, { useState } from 'react';
import UserDetailsContext from '../context/userDetails.context';

const UserDetailsProvider = ({ children }) => {


    /**
     * User details state / controls
     */
    const setUserDetails = ({
        userId,
        userName,
        email,
        userLocations,
        token
    }) => {
        updateUserDetails(prevState => {
            const newUserState = {
                ...prevState, userId: userId, userName: userName, email: email, userLocations: userLocations, token: token
            };
            return newUserState;
        });
    };

    const setUserEmail = (newEmail) => {
        updateUserDetails(prevState => {
            return {...prevState, email: newEmail}
        });
    }

    const initialUserState = {
        userId: '',
        userName: '',
        email: '',
        userLocations: [],
        token: '',
        setUserDetails,
        setUserEmail
    };

    function getInitialState() {
        var userStateLocalStorage;
        try {
            const fromLocalStorage = JSON.parse(localStorage.getItem('userDetails'));
            if (fromLocalStorage) {
                userStateLocalStorage = { ...fromLocalStorage, setUserDetails, setUserEmail };
            }
            return userStateLocalStorage || initialUserState;
        }
        catch (error) {
            return initialUserState;
        }

    }

    const [userDetails, updateUserDetails] = useState(getInitialState);

    React.useEffect(() => {
        localStorage.setItem('userDetails', JSON.stringify(userDetails));
    }, [userDetails]);


    return (
        <UserDetailsContext.Provider value={userDetails}>
            {children}
        </UserDetailsContext.Provider>
    );
};

export default UserDetailsProvider;


// WEBPACK FOOTER //
// ./src/components/UserDetailsProvider.js